import type { ClassNames, Locale } from 'react-day-picker';
import { de, enUS } from 'react-day-picker/locale';

import { cn } from '../../utils/cn';

export const localeMap: Record<string, Locale> = {
    de,
    en: enUS,
};

export const getCalendarClassNames = (customClassNames?: Partial<ClassNames>) => ({
    button_next: cn(
        'absolute right-0 top-0',
        'inline-flex items-center justify-center',
        'size-8 rounded border border-grey-dark',
        'text-midnight opacity-50',
        'hover:opacity-100 hover:bg-grey-light',
        'focus:outline-none focus:ring-2 focus:ring-blue-focus focus:ring-offset-1',
        'disabled:opacity-30 disabled:cursor-not-allowed select-none',
    ),
    button_previous: cn(
        'absolute left-0 top-0',
        'inline-flex items-center justify-center',
        'size-8 rounded border border-grey-dark',
        'text-midnight opacity-50',
        'hover:opacity-100 hover:bg-grey-light',
        'focus:outline-none focus:ring-2 focus:ring-blue-focus focus:ring-offset-1',
        'disabled:opacity-30 disabled:cursor-not-allowed select-none',
    ),

    caption_label: 'text-sm font-medium text-midnight inline-flex items-center gap-1 select-none',

    chevron: 'size-4',

    day: cn('relative p-0 text-center text-sm select-none', 'focus-within:relative focus-within:z-20'),
    day_button: cn(
        'size-9 rounded-md',
        'inline-flex items-center justify-center',
        'text-sm font-normal text-midnight',
        'hover:bg-grey-light hover:rounded-md',
        'focus:outline-none focus:ring-2 focus:ring-blue-focus focus:ring-offset-1',
        'aria-selected:opacity-100',
    ),

    disabled:
        '[&>button]:text-midnight-disabled [&>button]:opacity-50 [&>button]:cursor-not-allowed [&>button]:hover:bg-transparent',

    dropdown: cn('absolute inset-0 w-full opacity-0 cursor-pointer z-10 focus:outline-none'),
    dropdown_root: cn(
        'relative inline-flex items-center gap-1 px-2 py-1 rounded border border-grey-dark',
        'text-sm font-medium text-midnight hover:bg-grey-light cursor-pointer',
    ),
    dropdowns: cn('flex flex-row items-center gap-2'),

    hidden: 'invisible',

    month: 'relative flex flex-col gap-4',
    month_caption: 'flex justify-center items-center h-8 mx-9',

    months: 'flex gap-4',

    nav: 'hidden',

    outside: '[&>button]:text-[#71717a] [&>button]:opacity-50',

    range_end: cn(
        'bg-surface-light rounded-r-md',
        '[&>button]:!bg-midnight [&>button]:!text-white [&>button]:!border-transparent [&>button]:rounded-md',
        '[&>button]:hover:!bg-midnight-hover',
    ),
    range_middle: cn(
        '!bg-surface-light rounded-none',
        '[&>button]:!bg-transparent [&>button]:!border-transparent [&>button]:rounded-none',
        '[&>button]:hover:bg-midnight [&&&>button]:hover:!text-white',
        '[&&&>button]:!text-midnight',
    ),
    range_start: cn(
        'bg-surface-light rounded-l-md',
        '[&>button]:!bg-midnight [&>button]:!text-white [&>button]:!border-transparent [&>button]:rounded-md',
        '[&>button]:hover:!bg-midnight-hover',
    ),

    root: 'font-roboto',

    selected: cn(
        '[&>button]:!bg-midnight [&>button]:!text-white [&>button]:!border-transparent',
        '[&>button]:hover:!bg-midnight-hover [&>button]:hover:!text-white',
    ),

    today: '[&>button]:border [&>button]:border-midnight [&>button]:bg-surface-light',

    week: 'flex',

    weekday: 'w-9 h-[21px] text-xs font-normal text-[#71717a] flex items-center justify-center select-none',
    weekdays: 'flex',
    weeks: 'flex flex-col gap-2',

    ...customClassNames,
});
